import { Card } from '../../../../components/atoms';
import { useAuth } from '../../../../store/auth';
import { HiOutlineUser, HiOutlineEnvelope } from 'react-icons/hi2';
import { useTranslation } from 'react-i18next';

const ProfileCard = () => {
  const { user } = useAuth();
  const { t } = useTranslation();

  const fullName = user?.first_name && user?.last_name 
    ? `${user.first_name} ${user.last_name}` 
    : user?.first_name || user?.last_name || 'User';

  const initials = user?.first_name?.charAt(0).toUpperCase() || 'U';

  return (
    <Card.Root className="w-full">
      <Card.Header>
        <div className="flex flex-col gap-1">
          <h3 className="text-lg font-semibold">{t('preferences.profileInformation')}</h3>
        </div>
      </Card.Header>

      <Card.Content>
        <div className="flex flex-col gap-4">
          {/* User Avatar */}
          <div className="flex items-center gap-4">
            <div className="flex h-16 w-16 items-center justify-center rounded-full bg-gradient-to-br from-blue-500 to-blue-600 text-2xl font-bold text-white shadow-lg">
              {initials}
            </div>
            <div className="flex flex-col">
              <span className="text-base font-semibold text-gray-800">{fullName}</span>
              <span className="text-sm text-gray-500">{t('preferences.accountMember')}</span>
            </div>
          </div>

          {/* Divider */}
          <div className="border-t border-gray-200"></div>

          {/* Info Fields */}
          <div className="flex flex-col gap-3">
            <div className="flex items-center gap-3 rounded-lg bg-gray-50 p-3">
              <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-blue-100">
                <HiOutlineUser className="text-blue-600" size={20} />
              </div>
              <div className="flex flex-col">
                <span className="text-xs text-gray-500">{t('preferences.fullName')}</span>
                <span className="text-sm font-medium text-gray-800">{fullName}</span>
              </div>
            </div>

            <div className="flex items-center gap-3 rounded-lg bg-gray-50 p-3">
              <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-green-100">
                <HiOutlineEnvelope className="text-green-600" size={20} />
              </div>
              <div className="flex flex-col">
                <span className="text-xs text-gray-500">{t('preferences.emailAddress')}</span>
                <span className="text-sm font-medium text-gray-800">{user?.email || t('preferences.notProvided')}</span>
              </div>
            </div>
          </div>
        </div>
      </Card.Content>
    </Card.Root>
  );
};

export { ProfileCard };

